import "./globals.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./lib/auth-context";
import { Router } from "./lib/router";
import { ErrorBoundary } from "./components/error-boundary";
import { useOnline } from "./lib/use-online";
import Home from "./pages/home";
import Login from "./pages/login";
import Dictate from "./pages/dictate";
import Settings from "./pages/settings";
import Survey from "./pages/survey";

function withErrorBoundary(Component: React.ComponentType, message?: string) {
  return function WrappedWithErrorBoundary() {
    return (
      <ErrorBoundary fallbackMessage={message}>
        <Component />
      </ErrorBoundary>
    );
  };
}

const routes = [
  { pattern: "/", component: withErrorBoundary(Home) },
  { pattern: "/login", component: withErrorBoundary(Login, "Login failed to load.") },
  { pattern: "/dictate/:id", component: withErrorBoundary(Dictate, "Dictation page encountered an error.") },
  { pattern: "/settings", component: withErrorBoundary(Settings, "Settings failed to load.") },
  { pattern: "/survey/:id", component: withErrorBoundary(Survey, "Survey page encountered an error.") },
];

function OfflineBanner() {
  const isOnline = useOnline();
  if (isOnline) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-600 text-white text-center text-sm py-1.5 px-4">
      You're offline — drafts are saved locally, but AI structuring and publishing require a connection.
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <OfflineBanner />
      <Router routes={routes} />
    </AuthProvider>
  );
}

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
